// extracted by mini-css-extract-plugin
module.exports = {"container":"ColumnContainer_container_3ox5y"};